import {
  WidgetInstance,
} from 'mobx-store/stores/customScreens/types';
import { ValidationOptionsKeys } from 'screens/addEditCustomScreen/types';
import { ValidationSchema } from '../validation.helper';

export interface Props {
  focusedWidgetData: WidgetInstance;
  focusedWidget: null | string | number;
  handleChangeData: (paramName: string, value: any) => void;
  handleMultipleChangeData: (params: {}) => void;
  removeFocusedWidget: () => void;
}


export const homePointsWidgetValidation: ValidationSchema =  {
  title: [{ validation: [ValidationOptionsKeys.REQUIRED],}],
  pointsSpan: [{ validation: [ValidationOptionsKeys.REQUIRED],}],
}